import React from 'react'
import PropTypes from 'prop-types'
import Dollars from '../../../Dollars/Dollars'

import './MenuItemPrice.css'

export const MenuItemPrice = ({ price, usesFractionalQuantity = false, unitOfMeasure = '' }) => (
  <span data-testid='menu-item-price' styleName='price'>
    <Dollars amount={price} />
    {usesFractionalQuantity && `/${unitOfMeasure.toLowerCase()}`}
  </span>
)

MenuItemPrice.propTypes = {
  price: PropTypes.number.isRequired,
  usesFractionalQuantity: PropTypes.bool,
  unitOfMeasure: PropTypes.string
}
